export const primaryGreen = "#6BF4BE";
export const primaryWhite = "#FFFFFF";
export const primaryBlack = "#29303A";
